type JOB_STATUS = 'ACTIVE' | 'INACTIVE';

export interface IEXPERIENCE_FORMULA {
  jobStatus: JOB_STATUS | undefined;
  dateOfJoining?: string | undefined;
  dateOfJoiningWhenLeft?: string | undefined;
  dateOfLeaving?: string | undefined;
}

type EXPERIENCE_RESPONSE = {
  totalExperience: string;
};

type DATE_DIFFERENCE = { years: number; months: number; days: number };

export function getDateDifference(
  startDateStr: string,
  endDateStr: string
): DATE_DIFFERENCE {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();

  if (days < 0) {
    months -= 1;
    const lastDayOfPrevMonth = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      0
    ).getDate();
    days += lastDayOfPrevMonth;
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return { years, months, days };
}

function createDateOutputString(
  years: number,
  months: number,
  days: number
): string {
  if (years === 0 && months === 0 && days === 0) {
    return '0 days';
  }

  const parts = [];

  if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
  if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
  if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);

  return parts.join(' ');
}

export const EXPERIENCE_CALCULATOR_FORMULA = ({
  dateOfJoining,
  dateOfLeaving,
}: IEXPERIENCE_FORMULA): EXPERIENCE_RESPONSE => {
  if (!dateOfJoining) {
    return { totalExperience: '0 days' };
  }

  //if dateofleaving is undefined, the calculator assumes today's date as the date of leaving

  const startDate = new Date(dateOfJoining);
  let endDate;
  if (!dateOfLeaving) {
    endDate = new Date();
  } else {
    endDate = new Date(dateOfLeaving);
  }
  // invalid date range
  if (startDate >= endDate) {
    return { totalExperience: '0 days' };
  }

  const dateDiffResp = getDateDifference(
    startDate.toISOString().slice(0, 10),
    endDate.toISOString().slice(0, 10)
  );

  return {
    totalExperience: createDateOutputString(
      dateDiffResp.years,
      dateDiffResp.months,
      dateDiffResp.days
    ),
  };
};
